import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/frontend/src/components/NotificationsGrid/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/frontend/src/providers/nextAuth.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/frontend/src/providers/reactQuery.provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/frontend/src/styles/global.css");
